export const proporsalService = {
  getOrders,
  getOrderDetail,
  getApollo,
  getTargetSequences,
  loadCampaingStepTarget,
  getCampaignStepTemplates,
  saveSepaPaymentMethod,
  confirmPaymentMethod,
  getPaymentMoethod,
  setSepaPaymentMethod,
  saveBankTransferPaymentMethod,
  getContractClient,
};

const apiUrl = process.env.VUE_APP_ROOT_API;

function getOrders(client_id = null) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  };
  return fetch(`${apiUrl}/proporsal/orders/${client_id}`, requestOptions).then(
    handleResponse
  );
}

function getPaymentMoethod(paymentMehodId = null) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  };
  return fetch(
    `${apiUrl}/proporsal/get-payment-method/${paymentMehodId}`,
    requestOptions
  ).then(handleResponse);
}

function getOrderDetail(target_id = null) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  };
  return fetch(
    `${apiUrl}/proporsal/order-detail/${target_id}`,
    requestOptions
  ).then(handleResponse);
}

function getApollo(data) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ data }),
  };
  return fetch(`${apiUrl}/proporsal/get-apollo`, requestOptions).then(
    handleResponse
  );
}

function getTargetSequences(target_id) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(target_id),
  };
  return fetch(`${apiUrl}/proporsal/get-target-sequences`, requestOptions).then(
    handleResponse
  );
}

function loadCampaingStepTarget(data) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  };
  return fetch(
    `${apiUrl}/proporsal/load-campaing-step-target`,
    requestOptions
  ).then(handleResponse);
}

function saveSepaPaymentMethod(paymentMethod) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(paymentMethod),
  };

  return fetch(`${apiUrl}/proporsal/payment-method`, requestOptions).then(
    handleResponse
  );
}

function confirmPaymentMethod(ingenicoResponse) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(ingenicoResponse),
  };
  return fetch(
    `${apiUrl}/proporsal/payment-method/confirmed`,
    requestOptions
  ).then(handleResponse);
}

function setSepaPaymentMethod(data) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  };

  return fetch(`${apiUrl}/proporsal/payment-method/sepa`, requestOptions).then(
    handleResponse
  );
}

function saveBankTransferPaymentMethod(data) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  };

  return fetch(
    `${apiUrl}/proporsal/payment-method/bank-transfer`,
    requestOptions
  ).then(handleResponse);
}

function getCampaignStepTemplates(model) {
  let searchFilter = getDefault(model);
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ searchFilter }),
  };

  return fetch(
    `${apiUrl}/proporsal/get-campaign-step-templates`,
    requestOptions
  ).then(handleResponse);
}

function getContractClient(client_id) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  };
  return fetch(
    `${apiUrl}/proporsal/get-contract?client_id=${client_id}`,
    requestOptions
  ).then(handleBlobDownloadResponse);
}

function getDefault(model) {
  let searchFilter = Array();
  searchFilter = {
    currentPage:
      model.currentPage !== undefined
        ? JSON.stringify(model.currentPage)
        : undefined,
    cantPerPage:
      model.cantPerPage !== undefined
        ? JSON.stringify(model.cantPerPage)
        : undefined,
    total: model.total !== undefined ? JSON.stringify(model.total) : undefined,
    client_id:
      model.client_id !== undefined
        ? JSON.stringify(model.client_id)
        : undefined,
    from_owarm_id:
      model.from_owarm_id !== undefined
        ? JSON.stringify(model.from_owarm_id)
        : undefined,
    step: model.step !== undefined ? model.step : undefined,
    campaign_step_template_type_id:
      model.campaign_step_template_type_id !== undefined
        ? model.campaign_step_template_type_id
        : undefined,
    campaign_step_template_part_id:
      model.campaign_step_template_part_id !== undefined
        ? model.campaign_step_template_part_id
        : undefined,
    id: model.id !== undefined ? model.id : undefined,
    parent_id: model.parent_id !== undefined ? model.parent_id : undefined,
    language_id:
      model.language_id !== undefined ? model.language_id : undefined,
    isPreviewEmail:
      model.isPreviewEmail !== undefined ? model.isPreviewEmail : undefined,
    tag_id: model.tag_id !== undefined ? model.tag_id : undefined,
    withTags: model.withTags !== undefined ? model.withTags : undefined,
    queue_status:
      model.queue_status !== undefined ? model.queue_status : undefined,
    tab_selected:
      model.tab_selected !== undefined ? model.tab_selected : undefined,
  };
  return searchFilter;
}

function handleResponse(response) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      const error = data || response.statusText;
      return Promise.reject(error);
    }
    return data;
  });
}

function filenameFromContentDisposition(header) {
  if (!header) return null;

  // filename*=UTF-8''nombre.pdf (RFC 5987)
  const utf8Match = header.match(/filename\*=UTF-8''([^;\n]+)/i);
  if (utf8Match) {
    try {
      return decodeURIComponent(utf8Match[1].trim());
    } catch (e) {
      return utf8Match[1].trim();
    }
  }

  // filename="contract-ABC.pdf"
  const quotedMatch = header.match(/filename="([^"]+)"/i);
  if (quotedMatch) return quotedMatch[1];

  // filename=contract-ABC.pdf
  const unquotedMatch = header.match(/filename=([^;\n]+)/i);
  if (unquotedMatch) {
    return unquotedMatch[1].trim().replace(/^"|"$/g, "");
  }

  return null;
}

/** For endpoints that return raw PDF bytes (not JSON). */
function handleBlobDownloadResponse(response) {
  if (!response.ok) {
    return response.text().then((text) => {
      let error = response.statusText;
      try {
        const parsed = text && JSON.parse(text);
        error =
          typeof parsed === "string"
            ? parsed
            : (parsed && parsed.message) || (parsed && parsed.error) || error;
      } catch (e) {
        if (text) {
          error = text.slice(0, 200);
        }
      }
      return Promise.reject(error);
    });
  }

  const filename = filenameFromContentDisposition(
    response.headers.get("Content-Disposition")
  );
  return response.blob().then((blob) => ({ blob, filename }));
}
